var Textline = {};

Textline.Widget = function(phone_number, user_opts) {
    var on_doc_ready,
        widget;

    this.animating = false;
    this.visible = false;
    this.phone_number = phone_number.replace(/[^\d+]/gi, '');

    user_opts = user_opts || {};
    this.setupWidgetOpts(user_opts);
    this.createWidgetContainer();

    if (location.search == '?textline_debug') {
        this.generateDebugConsole();
    }
    if ((!this.detectPhone() && !user_opts.force_display) && !(location.search == "?force_textline" || this.debug_console)) {
        return;
    }

    widget = this;
    
    on_doc_ready = function() {
        widget.close_button.addEventListener('click', function() {
            widget.widget_container.style.transition = 'bottom 0.2s cubic-bezier(.02, .01, .47, 1)';
            widget.widget_container.style.bottom = widget.initBottomPosition();
            // setTimeout(function() { widget.widget_container.parentNode.removeChild(widget.widget_container); }, 1000);
        });

        document.getElementsByTagName('body')[0].appendChild(widget.widget_container);
        widget.position();
        widget.setupScrollHandling();
    }
    if (document.addEventListener) {
        document.addEventListener('DOMContentLoaded', on_doc_ready, false);
    }
};


Textline.Widget.prototype.setupWidgetOpts = function(user_opts) {
    this.opts = {};

    this.opts.background_color = user_opts.background_color || '#011EFF';
    this.opts.font_color = user_opts.font_color || '#FFFFFF';
    this.opts.height = user_opts.height || 58;
    this.opts.font_family = user_opts.font_family || "Helvetica";
    this.opts.font_size = user_opts.font_size || '20px';
    this.opts.prefill = user_opts.prefill;
    this.opts.text = user_opts.text || 'Text Us';

    this.opts.scroll_target = user_opts.scroll_target;
    this.opts.scroll_threshold = user_opts.scroll_threshold;
    this.opts.bottom_offset = user_opts.bottom_offset || 10;

    this.opts.widget_id = user_opts.id || 'textline-widget';
};


Textline.Widget.prototype.createWidgetContainer = function() {
    this.widget_container = document.createElement('div');
    this.widget_container.setAttribute('id', this.opts.widget_id);

    this.widget_container.style.position = 'fixed';
    this.widget_container.style.left = '50%';
    this.widget_container.style.zIndex = '1000';
    this.widget_container.style.transition = 'initial';

    this.createWidget();
    this.createCloseButton();
};


Textline.Widget.prototype.createWidget = function() {
    var ref,
        tail;

    this.widget = document.createElement('a');
    ref = 'sms:' + this.phone_number
    if (this.opts.prefill) {
        ref += ';?&body=' + encodeURIComponent(this.opts.prefill);
    }
    this.widget.setAttribute('href', ref);
    this.widget.setAttribute('target', '_blank');

    this.widget.style.textDecoration = 'none'
    this.widget.style.display = 'block'
    this.widget.style.backgroundColor = this.opts.background_color;
    this.widget.style.whiteSpace = 'nowrap';
    this.widget.style.padding = ((this.opts.height-26)/2) + 'px 47px 0px';
    this.widget.style.borderRadius = '2px';
    this.widget.style.transition = 'initial';

    this.widget.style.position = 'absolute';
    this.widget.style.top = '0px';
    this.widget.style.left = '0px';

    this.content = document.createElement('div');
    this.content.style.height = (this.opts.height-(this.opts.height-26)/2) + 'px';
    this.content.style.lineHeight = '26px';
    this.widget.appendChild(this.content);

    tail = document.createElement('div');
    tail.style.borderTop = '32px solid' + this.opts.background_color;
    tail.style.borderRight = '44px solid transparent';
    tail.style.position = 'absolute';
    tail.style.bottom = '-32px';
    tail.style.left = '50%';
    tail.style.marginLeft = '-22px';
    this.widget.appendChild(tail);

    this.createTextNode();
    
    this.widget_container.appendChild(this.widget);
};


Textline.Widget.prototype.createCloseButton = function() {
    this.close_button = document.createElement('div');

    this.close_button.style.backgroundColor = this.opts.background_color;
    this.close_button.style.borderRadius = '50%';
    this.close_button.style.height = '32px';
    this.close_button.style.width = '32px';
    this.close_button.style.transition = 'initial';
    this.close_button.style.cursor = 'pointer';

    this.close_button.style.position = 'absolute';
    this.close_button.style.top = '0px';
    this.close_button.style.right = '-7px';

    this.createCrossIcon();

    this.widget_container.appendChild(this.close_button);
};


Textline.Widget.prototype.createCrossIcon = function() {
    var slash_forward,
        slash_backward; 

    slash_forward = document.createElement('div');
    slash_backward = document.createElement('div');

    slash_forward.style.backgroundColor = slash_backward.style.backgroundColor = this.opts.font_color;

    slash_forward.style.width = slash_backward.style.width = '2px';
    slash_forward.style.height = slash_backward.style.height = '14px';
    slash_backward.style.transform = 'rotate(-45deg)';
    slash_forward.style.transform = 'rotate(-135deg)';
    slash_forward.style.marginLeft = slash_backward.style.marginLeft = -1*(parseFloat(slash_forward.style.width)/2) + 'px';
    slash_forward.style.marginTop = slash_backward.style.marginTop = -1*(parseFloat(slash_forward.style.height)/2) + 'px';

    slash_forward.style.position = slash_backward.style.position = 'absolute';
    slash_forward.style.top = slash_backward.style.top = '50%';
    slash_forward.style.left = slash_backward.style.left = '50%';

    this.close_button.appendChild(slash_forward);
    this.close_button.appendChild(slash_backward); 
};


Textline.Widget.prototype.createTextNode = function() {
    this.text_node = document.createElement('span');

    this.text_node.style.color = this.opts.font_color;
    this.text_node.style.fontFamily = this.opts.font_family;
    this.text_node.style.fontSize = this.opts.font_size;
    this.text_node.style.fontWeight = '600';

    this.text_node.appendChild(document.createTextNode(this.opts.text));

    this.content.appendChild(this.text_node);
};


Textline.Widget.prototype.calculateSize = function() {
    this.widget_container.style.width = this.widget.clientWidth + this.close_button.clientWidth + 'px';
    this.widget_container.style.height = this.widget.clientHeight + this.widget.children[1].offsetHeight;
};


Textline.Widget.prototype.position = function() {
    if (this.animating) {
        return;
    }

    // Need to set the width and height of container to properly calculate its position
    this.calculateSize();

    this.widget_container.style.marginLeft = (-1*this.widget.clientWidth/2)+'px';

    if (this.visible) {
        this.widget_container.style.bottom = this.visibleBottomOffset()+'px';
    } else {
        this.widget_container.style.bottom = this.initBottomPosition();
    }
};


Textline.Widget.prototype.initBottomPosition = function() {
    return (-1*this.widget_container.clientHeight) + 'px';
};


Textline.Widget.prototype.show = function() {
    var animate,
        animation_end_pos,
        animation_start_pos,
        curr_pos,
        direction,
        final_pos,
        num_steps,
        overshoot,
        step,
        widget;

    if (this.visible) {
        return;
    }

    this.animating = true;
    this.visible = true;

    curr_pos = parseFloat(this.widget_container.style.bottom.slice(0,-2));
    final_pos = this.visibleBottomOffset();
    num_steps = 64;
    overshoot = this.visibleBottomOffset();
    direction = -1;
    animation_end_pos = curr_pos;
    widget = this;

    animate = function() {
        if (isNaN(curr_pos)) {
            return;
        }
        if (animation_end_pos == curr_pos) {
            overshoot = overshoot/2;
            if (overshoot <= 0.01) {
                overshoot = 0;
            }
            direction = -1*direction
            animation_end_pos = final_pos + direction * overshoot;
            animation_start_pos = curr_pos;


            if (animation_end_pos == final_pos) {
                widget.animating = false;
                widget.position();
                return;
            }

            num_steps = Math.ceil(num_steps/1.2);
            step = 0;
        }

        step += 1;
        curr_pos = animation_start_pos + widget.easeInOutQuad(step/num_steps) * direction * Math.abs(animation_start_pos - animation_end_pos);
        widget.widget_container.style.bottom = curr_pos + 'px';

        setTimeout(animate, 5);
    };

    animate();
};


Textline.Widget.prototype.setupScrollHandling = function() {
    var scroll_evt_handler,
        scroll_offset,
        widget;

    if (this.opts.scroll_target) {
        if (typeof(this.opts.scroll_target) == typeof('')) {
            this._scroll_target = document.getElementById(this.opts.scroll_target)
        } else {
            this._scroll_target = this.opts.scroll_target;
        }
    } else {
        this._scroll_target = window;
    }
    if (!this._scroll_target) {
        return;
    }

    widget = this

    scroll_evt_handler = function() {
        scroll_offset = widget._scroll_target.scrollY || widget._scroll_target.scrollTop || widget._scroll_target.pageYOffset || 0;
        if (scroll_offset >= widget.scrollThreshold()) {
            widget.show();
        }
    };
    this._scroll_target.addEventListener('scroll', scroll_evt_handler, false);
    scroll_evt_handler();
};


Textline.Widget.prototype.easeInOutQuad = function(t) {
    return t<.5 ? 2*t*t : -1+(4-2*t)*t
};


Textline.Widget.prototype.visibleBottomOffset = function() {
    return this.opts.bottom_offset;
};


Textline.Widget.prototype.scrollThreshold = function() {
    if (typeof(this.opts.scroll_threshold) == typeof(0)) {
        return this.opts.scroll_threshold;
    }
    return 100;
};


Textline.Widget.prototype.detectPhone = function() {
    var check = false;
    // http://detectmobilebrowsers.com/
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
};


Textline.Widget.prototype.generateDebugConsole = function() {
    this.debug_console = document.createElement('div');
    this.debug_console.style.position = 'fixed';
    this.debug_console.style.top = '0px';
    this.debug_console.style.left = '0px';
    this.debug_console.style.zIndex = '1000';
    this.debug_console.style.fontSize = '12px';
    this.debug_console.style.color = '#0F0';
    this.debug_console.style.background = '#000';
    this.debug_console.style.padding = '0px 8px';
    this.debug_console.innerHTML = 'debugging...';
    document.getElementsByTagName('body')[0].appendChild(this.debug_console);
};


Textline.Widget.prototype.log = function(msg) {
    if (this.debug_console) {
        this.debug_console.innerHTML = '' + msg;
    }
}